import { REFERIDO_PHASES } from '@/constants';
import type { ReferidoPhase } from '@/types';

interface PhaseIndicatorProps {
  currentPhase: ReferidoPhase;
}

const PHASE_ORDER: ReferidoPhase[] = ['names', 'messages', 'phones', 'details'];

export function PhaseIndicator({ currentPhase }: PhaseIndicatorProps) {
  const currentIdx = PHASE_ORDER.indexOf(currentPhase);

  return (
    <div className="flex items-center gap-1 w-full">
      {REFERIDO_PHASES.map((phase, index) => {
        const isCompleted = index < currentIdx;
        const isCurrent = index === currentIdx;

        return (
          <div key={phase.key} className="flex-1 flex flex-col items-center gap-1">
            {/* Bar */}
            <div
              className={`w-full h-1.5 rounded-full transition-colors ${
                isCompleted
                  ? 'bg-green-500'
                  : isCurrent
                    ? 'bg-primary-600'
                    : 'bg-gray-200'
              }`}
            />
            {/* Label */}
            <span
              className={`text-xs font-medium transition-colors ${
                isCompleted
                  ? 'text-green-600'
                  : isCurrent
                    ? 'text-primary-600'
                    : 'text-gray-400'
              }`}
            >
              {phase.label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
